<template>
    <template v-if="currentLayout == 'tabular'">
        <div v-if="this.first" class="Block Workflowcard Item heading">
            <div class="th-state" v-if="show('state')"></div>
            <div class="th-title" v-if="title_visible('workflowboard', workflowboardId)"
                 :class="{ hassort: isSortingColumn('title') }" @click="setSortingColumn('title')">
                {{ trans("Titel") }}
                <button class="sorting" :class="{ active: isSortingColumn('title') }">
                    <Icon :name="`sort-${getSortingOrder()}`"/>
                </button>
            </div>
            <template v-for="propertyfield in componentData.workflowlayout">
                <div class="th-spec" :class="{ hassort: isSortingColumn(propertyfield.property.id) }"
                     @click="setSortingColumn(propertyfield.property.id)">
                    {{ title(propertyfield) }}
                    <button class="sorting" :class="{ active: isSortingColumn(propertyfield.property.id) }">
                        <Icon :name="`sort-${getSortingOrder()}`"/>
                    </button>
                </div>
            </template>
            <div class="th-action" v-if="$slots.workflowcard_item_actions"></div>
            <div class="th-icon" v-if="iconButtons || iconButtonsPlaceholder"></div>
        </div>
        <div class="Block Workflowcard Item colored bgwhite" :class="{ [currentLayout]: true, useHand: allow('view') }"
             @click="handleClick($event,data)">
            <div class="td-state" v-if="show('state')">
                <state v-if="data.priority" :value="data.priority"/>
            </div>
            <div class="td-title" v-if="title_visible('workflowboard', workflowboardId)">
                <h3 class="h3" v-if="workflowboardId">
                    <span v-if="show('abbreviation')" class="abbreviation"
                          :style="`--bgcolor: ${abbreviation(resolveTitle(data, workflowboardId)).color}`">{{
                            abbreviation(resolveTitle(data, workflowboardId)).letter
                        }}</span>
                    <cardtitle v-if="data" :data="data" :workflowboard_id="workflowboardId" :key="data.id"/>
                </h3>
            </div>
            <template v-for="layout in componentData.workflowlayout">
                <div class="td-spec" :class="`td-${getAccessString(layout.label)}`">
                    <template v-for="property in mergedProperties(data, layout)">
                        <var v-if="property" :class="classes(data, property.field.id)">
                            <template v-if="resolvePropertyType(property) == 'MultiCardField'">
                                <span v-if="Array.isArray(property.value)" v-for="(value, index) in property.value">
                                    <cardtitle v-if="value" :id="value" :key="value" /><span v-if="index < property.value.length - 1">, </span>
                                </span>
                                <span v-else-if="property.value">
                                    <cardtitle v-if="property.value" :id="property.value" :key="property.value" />
                                </span>
                            </template>
                            <template v-else-if="resolvePropertyType(property) == 'CardField'">
                                <cardtitle v-if="property.value" :id="property.value" :key="property.value"/>
                            </template>
                            <template v-else-if="resolvePropertyType(property) == 'UserField'">
                                <carduser v-if="property.value" :id="property.value" :key="property.value"/>
                            </template>
                            <template v-else-if="resolvePropertyType(property) == 'CheckboxField'">
                                {{ formatActives(property.value) }}
                            </template>
                            <template v-else>
                                {{ formatValue(property) }}
                            </template>
                        </var>
                    </template>
                </div>
            </template>
            <div class="td-action" v-if="$slots.workflowcard_item_actions">
                <slot name="workflowcard_item_actions" :layout="this.layout" :data="this.data"/>
            </div>
            <div class="td-icon" v-if="iconButtons || iconButtonsPlaceholder">
                <template v-for="button in iconButtons">
                    <button class="more-icon" :class="{[button.class]: true}"
                            @click.prevent="handleIconButton(button.key)">
                        <Icon :name="button.icon"/>
                    </button>
                </template>
            </div>
        </div>
    </template>
    <template v-else-if="currentLayout === 'list'">
        <article class="Block Workflowcard Item" :class="{ [currentLayout]: true, useHand: allow('view') }"
                 @click="handleClick($event,data)">
            <div class="inner">
                <state v-if="show('state') && data.priority" :value="data.priority"/>
                <span v-if="show('abbreviation')" class="abbreviation"
                      :style="`--bgcolor: ${abbreviation(resolveTitle(data, workflowboardId)).color}`">{{
                        abbreviation(resolveTitle(data, workflowboardId)).letter
                    }}</span>
                <div class="heading">
                    <h3 v-if="title_visible('workflowboard', workflowboardId) && workflowboardId" class="h3">
                        <cardtitle v-if="data" :data="data" :workflowboard_id="workflowboardId" :key="data.id"/>
                    </h3>
                    <ul class="block-grid one-up specs" :key="Object.keys(componentData.properties).length">
                        <template v-for="layout in componentData.workflowlayout">
                            <li v-if="resolveProperty(data, layout.property.id)" @mouseover.prevent="handleTitle"
                                :data-title="title(layout)">
                                <!--<label v-if="title(layout).length < 20">{{ title(layout) }}</laformatValuebel>-->
                                <var :class="classes(data, layout.property.id)">
                                    <template v-for="property in mergedProperties(data, layout)">
                                        <template v-if="resolvePropertyType(property) == 'MultiCardField'">
                                            <span v-if="Array.isArray(property.value)" v-for="(value, index) in property.value">
                                                <cardtitle v-if="value" :id="value" :key="value" /><span v-if="index < property.value.length - 1">, </span>
                                            </span>
                                            <span v-else-if="property.value">
                                                <cardtitle v-if="property.value" :id="property.value" :key="property.value" />
                                            </span>
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'CardField'">
                                            <cardtitle v-if="property.value" :id="property.value" :key="property.value"/>
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'UserField'">
                                            <carduser v-if="property.value" :id="property.value" :key="property.value"/>
                                        </template>
                                        <template v-else-if="resolvePropertyType(property) == 'CheckboxField'">
                                            {{ formatActives(property.value) }}
                                        </template>
                                        <template v-else>
                                            {{ formatValue(property) }}
                                        </template>
                                    </template>
                                </var>
                            </li>
                        </template>
                    </ul>
                </div>
                <div class="actions" v-if="$slots.workflowcard_item_actions">
                    <slot name="workflowcard_item_actions" :layout="this.layout" :data="this.data"/>
                </div>
                <div class="icons" v-if="iconButtons">
                    <template v-for="button in iconButtons">
                        <button class="more-icon" :class="{[button.class]: true}"
                                @click.prevent="handleIconButton(button.key)">
                            <Icon :name="button.icon"/>
                        </button>
                    </template>
                </div>
            </div>
        </article>
    </template>
    <template v-else>
        <article ref="elRef" class="Block Workflowcard Item colored bgwhite"
                 :class="{ 'default': (currentLayout !== 'list'), [currentLayout]: true, useHand: allow('view') }"
                 @click="handleClick($event,data)">
            <div class="inner">
                <state v-if="show('state') && data.priority" :value="data.priority"/>
                <span v-if="show('abbreviation')" class="abbreviation"
                      :style="`--bgcolor: ${abbreviation(resolveTitle(data, workflowboardId)).color}`">{{
                        abbreviation(resolveTitle(data, workflowboardId)).letter
                    }}</span>
                <h3 v-if="title_visible('workflowboard', workflowboardId) && workflowboardId" class="h3">
                    <cardtitle v-if="data" :data="data" :workflowboard_id="workflowboardId" :key="data.id"/>
                </h3>
                <ul class="block-grid one-up specs" :key="Object.keys(componentData.properties).length">
                    <template v-for="layout in componentData.workflowlayout">
                        <li v-if="resolveProperty(data, layout.property.id)" @mouseover.prevent="handleTitle"
                            :data-title="title(layout)">
                            <label v-if="title(layout).length < 20">
                                {{ title(layout) }}
                            </label>
                            <var :class="classes(data, layout.property.id)">
                                <template v-for="property in mergedProperties(data, layout)">
                                    <template v-if="resolvePropertyType(property) == 'MultiCardField'">
                                        <span v-if="isVisible && Array.isArray(property.value)" v-for="(value, index) in property.value">
                                            <cardtitle v-if="value" :id="value" :key="value" /><span v-if="index < property.value.length - 1">, </span>
                                        </span>
                                        <span v-else-if="isVisible && property.value">
                                            <cardtitle v-if="property.value" :id="property.value" :key="property.value" />
                                        </span>
                                    </template>
                                    <template v-else-if="resolvePropertyType(property) == 'CardField'">
                                        <cardtitle v-if="isVisible && property.value" :id="property.value" :key="property.value"/>
                                    </template>
                                    <template v-else-if="resolvePropertyType(property) == 'UserField'">
                                        <carduser v-if="isVisible && property.value" :id="property.value"
                                                  :key="property.value"/>
                                    </template>
                                    <template v-else-if="resolvePropertyType(property) == 'CheckboxField'">
                                        {{ formatActives(property.value) }}
                                    </template>
                                    <template v-else>
                                        {{ formatValue(property) }}
                                    </template>
                                </template>
                            </var>
                        </li>
                    </template>
                </ul>
                <div class="actions" v-if="$slots.workflowcard_item_actions">
                    <slot name="workflowcard_item_actions" :layout="this.layout" :data="this.data"/>
                </div>
                <div class="icons" v-if="iconButtons">
                    <template v-for="button in iconButtons">
                        <button class="more-icon" :class="{[button.class]: true}"
                                @click.prevent="handleIconButton(button.key)">
                            <Icon :name="button.icon"/>
                        </button>
                    </template>
                </div>
                <div class="footer">
                    <div class="left">
                        <state v-if="show('state') && data.priority" :value="data.priority" :line="true"/>
                    </div>
                    <div class="right" v-if="show('icons')">
                        <button type="button" class="footer-button preview" @click.stop="handlePopover('details', data)">
                            <span class="inner">
                                <Icon name="view" />
                                <!--<span class="value"></span>-->
                            </span>
                        </button>
                        <button v-if="iconVisible('reactions')" type="button" class="footer-button comment" @click.stop="handlePopover('comments', data)">
                            <span class="inner">
                                <Icon name="message2" />
                                <!--<span class="value"></span>-->
                            </span>
                        </button>
                        <button v-if="iconVisible('files')" type="button" class="footer-button attachment" @click.stop="handlePopover('attachments', data)">
                            <span class="inner">
                                <Icon name="paperclip" />
                                <!--<span class="value"></span>-->
                            </span>
                        </button>
                        <button v-if="iconVisible('inbox') && componentData.inbox_total" type="button" class="footer-button inbox" @click.stop="handlePopover('inbox', data)">
                            <span class="inner">
                                <Icon name="email" />
                                <span class="value">{{ componentData.inbox_total }}</span>
                            </span>
                        </button>
                    </div>
                </div>
            </div>
        </article>
    </template>
</template>

<script>
import {defineComponent, computed, onMounted, reactive, ref, inject, watch} from "vue";
import {useRouter} from "vue-router";

// Helper functions
import {formatActives, formatValue} from "helpers/_formatting";
import trans from "helpers/_translation";

import {deleteDataAsync} from "helpers/_api";

import { item, contact, role_disabled } from "store/portal";
import { company } from "store/company";
import { isSortingColumn, setSortingColumn, getSortingOrder, getSortingColumn } from "store/sorting";
import { workflowlayout, resolvePropertyType, resolveProperty, resolveTitle } from "store/workflow";
import { addNotification } from "store/notifications";

// Our components
import Icon from "components/icon";

import State from "components/workflowcard/state";
import cardlink from "components/workflowcard/cardlink";
import carduser from "components/workflowcard/carduser";
import cardtitle from "components/workflowcard/cardtitle";

import {storeWorkflowcardPopoverData, openWorkflowcardPopover} from "store/workflowcard-popover";

import {abbreviation} from "helpers/_theme";

import {useIntersectionObserver} from 'composables/useIntersectionObserver';

// Config for API urls used in this vue template
import {apiHostname, config, env} from "config";

export default defineComponent({
    name: "workflowcard-item",
    components: {
        State,
        cardlink,
        carduser,
        cardtitle,
        Icon
    },
    props: {
        first: {
            type: Boolean,
            required: false,
            default: false
        },
        data: {
            type: Object,
            required: true
        },

        layout: {
            type: String,
            required: false,
            default: "tabular"
        },
        workflowphase_id: {
            type: String,
            required: false
        },
        workflowboard_id: {
            type: String,
            required: false
        },
        icon_buttons_by_role: {
            type: Boolean,
            required: false,
            default: false
        }
    },
    setup(props, {emit}) {
        const viewData = inject("viewData");
        const show = inject("show");

        const originalAllow = inject("allow");
        const overruledSettings = inject("overruledSettings") ?? {};
        const allow = (key) => {
            return computed(() => {
                if (overruledSettings?.value?.settings?.allow && (key in overruledSettings?.value?.settings?.allow)) {
                    return overruledSettings?.value?.settings?.allow?.[key];
                }
                return originalAllow(key);
            }).value;
        }

        const workflowboardId = computed(() => props.workflowboard_id);

        // Our configuration and constants
        const currentLayout = ref(props.layout);

        // Our component specific data
        const mergeMap = computed(() => {
            return env("merge_overview_mapping") ?? [];
        });
        const resolvedMergeValues = (layout) => {
            return computed(() => {
                return mergeMap.value.find(a => {
                    return a.workflowproperty_id?.[0] === `${layout.property.id}`;
                });
            }).value;
        };
        const mergedProperties = (data, layout) => {
            return computed(() => {
                const mergeValues = resolvedMergeValues(layout);
                if (mergeValues) {
                    return mergeValues.workflowproperty_id.map(id => {
                        return resolveProperty(data, id);
                    })
                }
                // Return the current one
                return [
                    resolveProperty(data, layout.property.id)
                ];
            }).value;
        };
        const componentData = reactive({
            properties: computed(() => props.data.extra.workflowproperties),
            workflowlayout: computed(() => {
                return workflowlayout(props.workflowboard_id, "overview")?.filter(layout => {
                    const isMergedProperty = mergeMap.value.some(a => {
                        return a.workflowproperty_id.includes(`${layout.property.id}`) && (a.workflowproperty_id?.[0] !== `${layout.property.id}`);
                    });
                    if (isMergedProperty) {
                        return false;
                    }

                    const tmpProperty = resolveProperty(props.data, layout.property.id);
                    if (company.value?.data?.id
                        && env("company_property_prefilled")?.includes(tmpProperty?.field?.name)
                    ) {
                        // Exclude properties which are prefilled by company, if company is set
                        return false;
                    }

                    return true;
                });
            })
        });

        // Events
        const handleItemClick = inject("handleItemClick");
        const handleClick = (e, data) => {
            if (!allow("view")) {
                // View not allowed
                return;
            }

            if (viewData.config?.settings?.type === "popover") {
                storeWorkflowcardPopoverData("details", data);
                openWorkflowcardPopover(props.workflowboard_id, props.workflowphase_id);
                return;
            }

            // if (props.related) return;
            // let url = `/workflowboard/${props.workflowboard_id}/workflowcard/${id}`;
            // router.push(url);
            // // window.location = url;
            const params = {
                workflowboard_id: `${props.workflowboard_id}`,
                workflowphase_id: `${props.workflowphase_id}`
            };
            if (viewData.workflowcard_id) {
                params.workflowcard_parent_id = `${viewData.workflowcard_id}`;
                params.workflowcard_id = `${data.id}`;
            } else {
                params.workflowcard_id = `${data.id}`;
            }
            console.log("params", params);
            handleItemClick(e, params);
        };

        const getAccessString = (string) => {
            return String(string.toLowerCase()).replace(" ", "_").replace(",", "");
        };

        const title = (data) => {
            return computed(() => {
                const mergeValues = resolvedMergeValues(data);
                if (mergeValues && mergeValues.title) {
                    return mergeValues.title;
                }
                return data.label;
            }).value;
        };

        const title_visible = (type, id) => {
            return computed(() => {
                const stateMap = env(`exclude_title_mapping.${type}`) ?? [];
                if (stateMap.some(a => `${a}` === `${id}`)) {
                    return false;
                }
                return true;
            }).value;
        };

        const handleTitle = (e) => {
            const target = e.currentTarget || e.target;

            let title = `${target.dataset.title}: `;
            const variable = target.querySelector("var");
            if (variable) {
                title += variable.innerText;
            }
            target.setAttribute("title", title);
        };

        const classes = (data, property_id) => {
            return computed(() => {
                const classnameMapping = env("variable_field_classname_mapping") ?? [];

                const tmpProperty = resolveProperty(data, property_id);
                if (!tmpProperty) {
                    return "";
                }
                const classes = [];
                tmpProperty.field?.name && classes.push(tmpProperty.field.name);

                const classnameTarget = classnameMapping.find(a => `${a.workflowpropertyfield_name}` === `${tmpProperty.field.name}`);
                if (classnameTarget) {
                    classes.push(classnameTarget.classname);
                    classes.push(classnameTarget.values?.[tmpProperty.value] ?? getAccessString(tmpProperty.value));
                }
                return classes;
            }).value;
        };


        const iconButtonsPlaceholder = ref(false);
        const iconButtons = computed(() => {
            const iconOptions = [
                {
                    "key": "delete",
                    "title": "Verwijderen",
                    "icon": "remove"
                }
            ];
            return iconOptions.filter(a => {
                if (props.icon_buttons_by_role && role_disabled(props.data)) {
                    // Hide since role is disabled
                    return false;
                }
                if (!allow(a.key)) {
                    return false;
                }
                if ((a.key === "delete") && (`${props.data.id}` === `${contact.value.data.id}`)) {
                    iconButtonsPlaceholder.value = true;
                    return false;
                }
                return true;
            });
        });
        const handleConfirmAction = inject("handleConfirmAction");
        const handleIconButton = (key) => {
            handleConfirmAction().then(
                () => {
                    if (key === "delete") {
                        deleteDataAsync(`${apiHostname}/api/v1.0/workflowcard/${props.data.id}`).then(() => {
                            addNotification(trans("De wijzigingen zijn succesvol verwerkt."), 3500);
                        });
                    }
                },
                () => {
                    // Rejected
                }
            )
        };

        // Observer for cards
        const elRef = ref(null);
        const {isVisible} = useIntersectionObserver(elRef);


        const handlePopover = (type, data) => {
            storeWorkflowcardPopoverData(type, data);
            openWorkflowcardPopover(props.workflowboard_id, props.workflowphase_id);
        };
        const iconVisible = (type) => {
            return computed(() => {
                // viewData.config?.settings?.disabled?.tabs
                if (viewData.config?.settings?.disabled?.tabs?.includes(type)) {
                    return false;
                }
                return true;
            }).value;
        }

        return {
            trans,
            show,
            allow,

            currentLayout,
            componentData,
            handleClick,

            resolveProperty,
            workflowboardId,

            getAccessString,
            resolvePropertyType,

            isSortingColumn,
            setSortingColumn,
            getSortingOrder,
            getSortingColumn,

            formatActives,
            formatValue,

            title,
            classes,

            mergedProperties,

            title_visible,

            handleTitle,

            resolveTitle,
            abbreviation,

            iconButtons,
            iconButtonsPlaceholder,
            handleIconButton,

            elRef,
            isVisible,

            handlePopover,
            iconVisible
        };
    },
});
</script>


<script setup>
</script>